// Inventory.tsx
import React, { useEffect, useRef, useState, useMemo } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  SelectChangeEvent,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectBrands,
  selectBrandSecurity,
  selectLocations,
  selectLocationSecurity,
  selectReport,
  selectServicerAppSecurity,
  selectSideMenuWidth,
  selectUserProfile,
} from 'src/app/selectors/appDataSelectors';
import {
  filtersData,
  selectClientType,
  selectSelectedBrand,
  selectSelectedClientConfig,
} from 'src/app/selectors/filterSelectors';
import { DataGrid, GridColDef, GridToolbar, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from '@mui/x-data-grid';
import { AppConfig } from 'src/config/AppConfig';
import { getActiveUsers, getReportsData } from 'src/slices/filterSlice';
import { useConfig } from 'src/context/ConfigContext';
import { getUrlForReports } from 'src/utils/DataMappings';
import { getPermissions } from 'src/utils/PermissionCheck';
import {
  capitalizeFirstLetter,
  createOrganizationsWithRoles,
} from 'src/utils/Utils';
import InviteUserModal from 'src/components/modals/InviteUserModal';
import EditUsertabModal from 'src/components/modals/EditUsertabModal';
import OrganizationRoleManager from 'src/components/modals/EditUserModal';
import RoleGroupManager from 'src/components/RoleGroupManager/RoleGroupManager';
import InviteInternalUserModal from 'src/components/modals/InviteInternalUserModal';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';

import {
  addnewUser,
  brandsDb,
  checkEmailExistsActiveUSers,
  checkEmailExistsInInvitation,
  deleteUserByEmail,
  locationsDb,
  servicerAppDb,
  userAppDb,
  editUserRoles,
} from 'src/config/firebaseConfig';
import ConfirmationModal from 'src/components/modals/ConfirmationModal';
import { useToast } from 'src/hooks/useToast';
import { FileDownloadOutlined, Info } from '@mui/icons-material';
import { COLUMN_CONFIG } from 'src/utils/ColumnUtils';
import { NMSCOLUMN_CONFIG } from 'src/utils/NMSColumnUtils';

import { selectLoader, selectError } from 'src/app/selectors/filterSelectors';
import Spinner from 'src/components/Spinner/Spinner';
interface RowData {
  [key: string]: any;
}

const TableView = () => {
  const dispatch = useDispatch();
  const { config } = useConfig();
  const selectedMenu = useSelector(selectReport);
  const clientType = useSelector(selectClientType);
  const currentConfig = useSelector(selectSelectedClientConfig);
  const [modalOpen, setModalOpen] = useState(false);
  const [inviteInternalmodalOpen, setInviteInternalmodalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [checked, setChecked] = useState(false);

  //selectSelectedClientConfig
  const [reportTile, setReportTile] = React.useState(
    localStorage.getItem('reportTile') || 'Transactions',
  );
  const userProfile = useSelector(selectUserProfile);
  const brandSecurity = useSelector(selectBrandSecurity);
  const locationSecurity = useSelector(selectLocationSecurity);
  const servicerAppSecurity = useSelector(selectServicerAppSecurity);
  const brands = useSelector(selectBrands);
  const locations = useSelector(selectLocations);
  const securityData =
    clientType === 'Brand' ? brandSecurity : locationSecurity;
  const [isEditModalOpen, setEditModalOpen] = useState<boolean>(false);
  const [isEditUsertabModalOpen, setEditUsertabModalOpen] = useState<boolean>(false);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  //const [userToDelete, setUserToDelete] = useState<string | null>(null); //
  const [userToDelete, setUserToDelete] = useState<RowData | null>(null);
  const { showSuccess, showError, showWarning } = useToast();

  const handleOpen = () => {
    if (selectedMenu === 'admin') {
      setInviteInternalmodalOpen(true);
    } else {
      setModalOpen(true);
    }
  };

  let internalInviteroles = brandSecurity ? brandSecurity.roles : {};
  let internalInvitebrandsorlocations: string[] = Object.keys(brands || {});
  const handleClose = () => setModalOpen(false);
  const handleCloseEditUsertab = () => setEditUsertabModalOpen(false);
  // Inside your component
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  // Define tab labels
  const tabLabels = [
    'Organization Users',
    'Organization Roles',
    'Location Users',
    'Location Roles',
    'ServicerApp Users',
    'ServicerApp Roles',
  ];

  const { permissions, isbrandAdminRole, superAdmin } = getPermissions(
    userProfile,
    securityData,
    clientType,
  );

  const handleDeleteConfirm = () => {
    if (userToDelete) {
      deleteUserByEmail(userToDelete, activeTab, (error, success) => {
        if (!success) {
          showError(`Failed to delete user with email: ${userToDelete.email}`);
        } else {
          showSuccess(
            `User with email ${userToDelete.email} deleted successfully.`,
          );
          dispatch(getActiveUsers({ selectedMenu: selectedMenu }));
        }
        setConfirmationModalOpen(false);
        setUserToDelete(null); // Reset userToDelete
      });
    }
  };

  const handleDeleteCancel = () => {
    setConfirmationModalOpen(false);
    setUserToDelete(null); // Reset userToDelete
  };
  const handleSaleChange = (event) => {
    const selected = event.target.checked; // Get the name of the checkbox
    setChecked(selected);
    applyFilter(reportTile);
  };

  const applyFilter = (tile: string) => {
    const headers = {
      Authorization: config['HEADER']['Authorization'],
    };
    let url = getUrlForReports(config.API_URL, tile);
    if (tile == AppConfig.reports[2]) {
      dispatch(
        getReportsData({
          url: url,
          headers,
          page: 1,
          selectedMenu: selectedMenu,
          selectedTile: tile,
          issaleZero: checked,
        }),
      );
    } else {
      dispatch(
        getReportsData({
          url: url,
          headers,
          page: 1,
          selectedMenu: selectedMenu,
          selectedTile: tile,
        }),
      );
    }
  };

  const handleChange = (event: SelectChangeEvent) => {
    const tile = event.target.value;
    setReportTile(tile as string);
    localStorage.setItem('reportTile', tile);
    applyFilter(tile);
  };
  const handleEdit = (event: SelectChangeEvent) => {
    if (selectedMenu == 'admin') {
      setEditModalOpen(!isEditModalOpen);
    } else {
      //setModalOpen(!modalOpen)
      setEditUsertabModalOpen(!isEditUsertabModalOpen);
    }

    setSelectedUser(event);
  };
  const handleSave = (selectedOrganizations: Organization[]) => {
    console.log('Saved Organizations:', selectedOrganizations);
  };

  const filterState = useSelector(filtersData);

  let selectedReportData = filterState[selectedMenu];
  let rows = [];

  const hasData =
  (selectedReportData?.data &&
    Array.isArray(Object.values(selectedReportData.data)) &&
    Object.values(selectedReportData.data).length > 0) ||
  (Array.isArray(selectedReportData) && selectedReportData.length > 0) ||
  (selectedReportData?.[reportTile] &&
    Object.values(selectedReportData[reportTile].data).length > 0);

  const isLoading = hasData? true: false;
  const isLoadingData = useSelector(selectLoader);
  const isError = useSelector(selectError);

  // Define columns for DataGrid
  let columns: GridColDef[] = [
    { field: 'store', headerName: 'Store', width: 150 },
    { field: 'memo', headerName: 'Location Name', width: 300 },
    { field: 'channel', headerName: 'Channel', width: 150 },
    { field: 'external_id', headerName: 'External ID', width: 150 },

    { field: 'planogram', headerName: 'Planogram', width: 200 },
    { field: 'product_sku', headerName: 'Product SKU', width: 150 },
    {
      field: 'product_alternate_skus',
      headerName: 'Alternate SKU',
      width: 150,
    },
    { field: 'product_upc', headerName: 'Product UPC', width: 150 },
    { field: 'product_name', headerName: 'Product Name', width: 300 },

    { field: 'inventory_level', headerName: 'Inventory Level', width: 150 },
    { field: 'in_transit', headerName: 'In Transit', width: 150 },
    { field: 'capacity', headerName: 'Max Capacity', width: 150 },
    { field: 'facings', headerName: '# Of Facings', width: 150 },
    {
      field: 'delivered_count',
      headerName: 'Sales (last 7 days)',
      width: 175,
    },
  ];
  if (selectedMenu === 'stores') {
    columns = COLUMN_CONFIG[selectedMenu];
  }
  if (selectedMenu === 'NMS-Worker-Logs') {
    columns = NMSCOLUMN_CONFIG[selectedMenu];
  }
  if (selectedMenu === 'NMS-Alert-Zendesk') {
    columns = NMSCOLUMN_CONFIG[selectedMenu];
  }
  if (selectedMenu === 'Alert-Rules') {
    columns = NMSCOLUMN_CONFIG[selectedMenu];
  }
  if (selectedMenu === 'users') {
    columns = COLUMN_CONFIG[selectedMenu];

    columns = columns.concat([
      {
        field: 'edit',
        headerName: 'Edit',
        width: 100,
        renderCell: (params) => (
          <>
            <IconButton onClick={() => handleEdit(params.row)} color="primary">
              <EditIcon />
            </IconButton>
          </>
        ),
      },
      {
        field: 'delete',
        headerName: 'Delete',
        width: 100,
        renderCell: (params) => (
          <IconButton onClick={() => handleDelete(params.row)} color="primary">
            <DeleteIcon />
          </IconButton>
        ),
      },
    ]);

    rows =
      selectedReportData?.data
        ?.filter((item) => {
          const hasValidBrands =
            item.brands &&
            (item.brands.allBrands ||
              (item.brands.exceptions &&
                typeof item.brands.exceptions === 'object' &&
                !Object.keys(item.brands.exceptions).includes(
                  currentConfig.brandKey,
                )) ||
              (item.brands.brandList &&
                typeof item.brands.brandList === 'object' &&
                Object.keys(item.brands.brandList).includes(
                  currentConfig.brandKey,
                )));

          // Check if the item has a valid 'servicerApp' configuration
          const hasValidServicerApp =
            item.servicerApp &&
            ((item.servicerApp.exceptions &&
              typeof item.servicerApp.exceptions === 'object' &&
              !Object.keys(item.servicerApp.exceptions).includes(
                currentConfig.brandKey,
              )) ||
              (item.servicerApp.brandList &&
                typeof item.servicerApp.brandList === 'object' &&
                Object.keys(item.servicerApp.brandList).includes(
                  currentConfig.brandKey,
                )));

          return !item.superAdmin && (hasValidBrands || hasValidServicerApp);
        })
        .map((item, index) => ({
          id: index, // Assign unique ID for DataGrid
          ...item,
        })) || [];

    // Function to handle delete action
    const handleDelete = (row: RowData) => {
      const email = row.email;
      if (row.superAdmin) {
        showWarning('change user type before you delete');
        return;
      }
      // setUserToDelete(email);
      setActiveTab(10);
      setUserToDelete(row);
      setConfirmationModalOpen(true);

      console.log(`Deleting user with ID: ${email}`);
    };
  } else if (selectedMenu === 'reports') {
    selectedReportData = selectedReportData[reportTile];
    columns = COLUMN_CONFIG[reportTile];

    const hasPermission =
      permissions &&
      permissions[
        `dash:brands:${selectedMenu}:${reportTile.toLowerCase()}:view`
      ];
    const isAuthorized = superAdmin || isbrandAdminRole;

    if (!isAuthorized && !hasPermission) {
      console.log('permissions', permissions);
      return <div>Nothing to show</div>;
    }

    // // Add extra columns at the start if reportTile is 'Sales' or 'Sessions Summary'
    if ((reportTile === 'Sales' || reportTile === 'Sessions Summary' || reportTile === 'Network Availability') 
       && (filterState.selectedFilter.aggregation === "Month")) {
      // Remove "Date" field from columns
      columns = columns.filter(column => column.field !== 'date');
      columns = [
        { field: 'year', headerName: 'Year', width: 150 },
        { field: 'month', headerName: 'Month', width: 150 },
        { field: 'days_included', headerName: 'Days Included', width: 150 },
        ...columns,
      ];
    }

  } else if (selectedMenu == 'admin') {
    columns = COLUMN_CONFIG[selectedMenu];
    columns = columns.concat([
      {
        field: 'edit',
        headerName: 'Edit',
        width: 100,
        renderCell: (params) => (
          <>
            <IconButton onClick={() => handleEdit(params.row)} color="primary">
              <EditIcon />
            </IconButton>
          </>
        ),
      },
      {
        field: 'delete',
        headerName: 'Delete',
        width: 100,
        renderCell: (params) => (
          <IconButton onClick={() => handleDelete(params.row)} color="primary">
            <DeleteIcon />
          </IconButton>
        ),
      },
    ]);
    const handleDelete = (row: RowData) => {
      const email = row.email;
      if (row.superAdmin) {
        showWarning('change user type before you delete');
        return;
      }
      // setUserToDelete(email);
      setUserToDelete(row);
      setConfirmationModalOpen(true);

      console.log(`Deleting user with ID: ${email}`);
    };
    internalInvitebrandsorlocations = Object.keys(brands || {});
    internalInviteroles = brandSecurity ? brandSecurity.roles : {};
    //
    if (activeTab == 0) {
      internalInvitebrandsorlocations = Object.keys(brands || {});
      internalInviteroles = brandSecurity ? brandSecurity.roles : {};
      rows =
        selectedReportData?.data
          ?.filter((item) => {
            return typeof item.brands === 'object' || item.superAdmin;
          })
          .map((item, index) => ({
            id: index, // Assign unique ID for DataGrid
            ...item,
            memberType: item.superAdmin ? 'Super Admin' : 'Member',
            organizations:
              item.brands || item.superAdmin
                ? item.superAdmin || item.brands.allBrands
                  ? 'All Organizations'
                  : Object.keys(item.brands?.brandList).map((item) => item)
                : '-',
            exceptions:
              item.brands &&
              item.brands.exceptions &&
              item.brands.exceptions.brands
                ? Object.keys(item.brands.exceptions.brands).map((item) => item)
                : '-',
          }))
          .sort((a, b) => {
            // Sort by `superAdmin` status, placing `superAdmin` first
            if (a.superAdmin && !b.superAdmin) return -1;
            if (!a.superAdmin && b.superAdmin) return 1;
            return 0;
          }) || [];
    } else if (activeTab == 1) {
      // org roles to be loaded
    }
    // Location user
    else if (activeTab == 2) {
      internalInvitebrandsorlocations = Object.keys(locations || {});
      internalInviteroles = locationSecurity.roles;

      rows =
        selectedReportData?.data
          ?.filter((item) => {
            return typeof item.locations === 'object' || item.superAdmin;
          })
          .map((item, index) => ({
            id: index, // Assign unique ID for DataGrid
            ...item,
            memberType: item.superAdmin ? 'Super Admin' : 'Member',
            organizations:
              item.locations || item.superAdmin
                ? item.superAdmin || item.locations.allLocations
                  ? 'All Locations'
                  : Object.keys(item.locations.locationList).map((item) => item)
                : '-',
            exceptions:
              item.locations &&
              item.locations.exceptions &&
              item.locations.exceptions.locations
                ? Object.keys(item.locations.exceptions.locations).map(
                    (item) => item,
                  )
                : '-',
          }))
          .sort((a, b) => {
            // Sort by `superAdmin` status, placing `superAdmin` first
            if (a.superAdmin && !b.superAdmin) return -1;
            if (!a.superAdmin && b.superAdmin) return 1;
            return 0;
          }) || [];
    } else if (activeTab == 4) {
      internalInviteroles = servicerAppSecurity.roles || {};
      internalInvitebrandsorlocations = Object.keys(brands || {});
      console.log('selectedReportData?.data', selectedReportData?.data);
      console.log(
        'filter',
        selectedReportData?.data?.filter((item) => {
          return typeof item.servicerApp === 'object' || item.superAdmin;
        }),
      );
      rows =
        selectedReportData?.data
          ?.filter((item) => {
            return typeof item.servicerApp === 'object' || item.superAdmin;
          })
          .map((item, index) => ({
            id: index, // Assign unique ID for DataGrid
            ...item,
            memberType: item.superAdmin ? 'Super Admin' : 'Member',
            organizations:
              item.servicerApp || item.superAdmin
                ? item.superAdmin || item.servicerApp.allBrands
                  ? 'All Organizations'
                  : Object.keys(item.servicerApp?.brandList ?? []).map(
                      (item) => item,
                    )
                : '-',
            exceptions:
              item.servicerApp &&
              item.servicerApp.exceptions &&
              item.servicerApp.exceptions.brands
                ? Object.keys(item.servicerApp.exceptions.brands).map(
                    (item) => item,
                  )
                : '-',
          }))
          .sort((a, b) => {
            // Sort by `superAdmin` status, placing `superAdmin` first
            if (a.superAdmin && !b.superAdmin) return -1;
            if (!a.superAdmin && b.superAdmin) return 1;
            return 0;
          }) || [];
    }
  }

  // Extract rows from data
  rows =
        rows.length === 0
          ? (selectedReportData?.data 
              ? Object.values(selectedReportData.data) 
              : Array.isArray(selectedReportData) 
              ? selectedReportData 
              : Object.values(selectedReportData || {})).map((item, index) => ({
                  id: index, // Assign unique ID for DataGrid
                  ...item,
                }))
          : rows;


  const dataSize = rows.length;

  const [page, setPage] = useState(0); // Page index
  const [pageSize, setPageSize] = useState(100); // Number of rows per page
  const [filters, setFilters] = useState({}); // Object to store filters for each column
  const [sortModel, setSortModel] = useState([]);
  useEffect(() => {
    if (rows.length <= 25) setPageSize(25);
    else if (rows.length <= 50) setPageSize(50);
    else if (rows.length <= 100) setPageSize(100);
    else setPageSize(25); // Default
  }, [rows]);
  // Handle filter changes for columns
  const handleFilterChange = (field, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [field]: value,
    }));
  };

  // Apply filters to the rows
  const filteredRows = rows.filter((row) =>
    Object.entries(filters).every(([field, value]) =>
      value
        ? row[field]?.toString().toLowerCase().includes(value.toLowerCase())
        : true,
    ),
  );

  // Apply sorting to the rows
  const sortedRows = [...filteredRows].sort((a, b) => {
    for (let { field, sort } of sortModel) {
      if (a[field] < b[field]) return sort === 'asc' ? -1 : 1;
      if (a[field] > b[field]) return sort === 'asc' ? 1 : -1;
    }
    return 0;
  });

  // Paginate the rows
  const displayedRows = sortedRows.slice(
    page * pageSize,
    (page + 1) * pageSize,
  );
  const totalPages = Math.ceil(filteredRows.length / pageSize);

  // Update page
  const handlePageChange = (event, value) => {
    setPage(value - 1); // Convert 1-based index (Pagination) to 0-based index (DataGrid)
  };

  // Update page size
  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0); // Reset to the first page
  };

  // Add filter input fields to the column headers
  const updatedColumns = columns.map((col) => ({
    ...col,
    renderHeader: (params) => (
      <Box>
        <Typography variant="subtitle2" gutterBottom>
          {params.colDef.headerName}
        </Typography>
        <TextField
          size="small"
          variant="outlined"
          placeholder={`Filter ${params.colDef.headerName}`}
          onChange={(e) => handleFilterChange(params.field, e.target.value)}
        />
      </Box>
    ),
  }));

  const handleInviteInternalUser = async (data: {
    email: string;
    roles: string[];
    allOrganizations: boolean;
    brands: string[];
  }) => {
    console.log('Invite Data:', data);
    const alpha = data.email.match(/@swyft|@zoomsystems/);
    if (alpha == null) {
      // toasts.error({
      //   message: `You are not allowed to invite internal users.`,
      //   autoDismissible: true,
      // });
      showWarning('You are not allowed to invite internal users.');
      return;
    }
    let isExistingInviteID = '';
    const isForExistingUser = await checkEmailExistsActiveUSers(
      userAppDb,
      data.email,
    );
    if (!isForExistingUser) {
      isExistingInviteID = await checkEmailExistsInInvitation(
        userAppDb,
        data.email,
      );
      if (isExistingInviteID) {
        console.error('Invite already there');
      }
    }
    let newUserData = {
      company: 'Swyft', // Assuming company is static, update if necessary
      dash: {
        activeBrand: currentConfig.brandKey || '', // Set the first brand as activeBrand
        activeType: clientType, // Assuming it's always "Brand"
        brands: {
          allBrands: data.allOrganizations,
          brandCommonRoles: data.roles.reduce((acc, roleId) => {
            acc[roleId] = true;
            return acc;
          }, {}),
        },
        enabled: true,
      },
      email: data.email,
      isForExistingUser: isForExistingUser.length > 0 ? true : false, // Assuming always true, update if necessary
      userType: 'internal', // Internal or External based on modal input
      appVersion: 'dashv2',
    };
    if (!data.allOrganizations) {
      const brandsRoles = {};
      data.brands.map(
        (brand) =>
          (brandsRoles[brand] = data.roles.reduce((acc, roleId) => {
            acc[roleId] = true;
            return acc;
          }, {})),
      );
      newUserData.dash.brands = {
        allBrands: data.allOrganizations,
        brandList: brandsRoles,
      };
    }

    console.log(newUserData);
    await addnewUser(newUserData, isExistingInviteID);
    setInviteInternalmodalOpen(false);
  };

  const handleInviteExternalUser = async (data: {
    email: string;
    roles: string[];
  }) => {
    let isExistingInviteID = '';
    const isForExistingUser = await checkEmailExistsActiveUSers(
      userAppDb,
      data.email,
    );
    if (!isForExistingUser) {
      isExistingInviteID = await checkEmailExistsInInvitation(
        userAppDb,
        data.email,
      );
      if (isExistingInviteID) {
        console.error('Invite already there');
      }
    }
    let brandsRoles = data.roles.reduce((acc, roleId) => {
      acc[roleId] = true;
      return acc;
    }, {});
    if (selectedUser) {
      showWarning('In Development');
    } else {
      let newUserData = {
        company: currentConfig.brandKey, // Assuming company is static, update if necessary
        dash: {
          activeBrand: currentConfig.brandKey || '', // Set the first brand as activeBrand
          activeType: clientType, // Assuming it's always "Brand"

          enabled: true,
        },
        email: data.email,
        isForExistingUser: isForExistingUser.length > 0 ? true : false, // Assuming always true, update if necessary
        userType: 'external', // Internal or External based on modal input
        appVersion: 'dashv2',
      };
      if (clientType == 'Brand') {
        newUserData = {
          company: currentConfig.brandKey, // Assuming company is static, update if necessary
          dash: {
            activeBrand: currentConfig.brandKey || '', // Set the first brand as activeBrand
            activeType: clientType, // Assuming it's always "Brand"
            brands: {
              brandList: {
                [currentConfig.brandKey]: brandsRoles,
              },
            },
            enabled: true,
          },
          email: data.email,
          isForExistingUser: isForExistingUser.length > 0 ? true : false, // Assuming always true, update if necessary
          userType: 'external', // Internal or External based on modal input
          appVersion: 'dashv2',
        };
      } else {
        newUserData = {
          company: currentConfig.brandKey, // Assuming company is static, update if necessary
          dash: {
            activeLocationPartner: currentConfig.brandKey || '', // Set the first brand as activeBrand
            activeType: clientType, // Assuming it's always "Brand"
            locations: {
              locationList: {
                [currentConfig.brandKey]: brandsRoles,
              },
            },
            enabled: true,
          },
          email: data.email,
          isForExistingUser: isForExistingUser, // Assuming always true, update if necessary
          userType: 'external', // Internal or External based on modal input
          appVersion: 'dashv2',
        };
      }
      console.log(newUserData);
      await addnewUser(newUserData, isExistingInviteID);
    }

    setModalOpen(false);
  };

  const handleEditUserRoles = async (data: {
    email: string;
    roles: string[];
    id: string;
    userType: string;
    org: string[];
  }) => {

    let isExistingInviteID = '';
    const isForExistingUser = await checkEmailExistsActiveUSers(
      userAppDb,
      data.email,
    );
    
    let brandsRoles = data.roles.reduce((acc, roleId) => {
      acc[roleId] = true;
      return acc;
    }, {});

    let newUserData ;

    if (data.userType == 'external') {
      ((clientType === 'Brand' || data.org?.includes('brands')) ?
        newUserData = {
          brandList: {
            [currentConfig.brandKey]: brandsRoles,
          }
        } :
        (clientType === 'locations' || data.org?.includes('locations')) ?
        newUserData = {
          locationList: {
            [currentConfig.brandKey]: brandsRoles,
          }
        } : 
        newUserData = {});
    } else {
      ((clientType === 'Brand' || data.org?.includes('brands')) ?
      newUserData = {
        brandCommonRoles: brandsRoles
      } :
      (clientType === 'locations' || data.org?.includes('locations')) ?
      newUserData = {
        locationCommonRoles: brandsRoles
      } : 
      newUserData = {});
    }
    console.log("newUserData", newUserData);
    const uuId = data.id;
    const userType = data.userType;

    await editUserRoles(newUserData, uuId, userType, clientType);
  }

  const exportToCSV = (rows, columns, fileName = "export") => {
    if (!rows.length) {
      alert("No data to export.");
      return;
    }
  
    // Extract column headers
    const headers = columns.map(col => col.headerName || col.field).join(",");
  
    // Convert row data to CSV format
    const csvData = rows.map(row => {
      return columns.map(col => {
        let value = row[col.field];
  
        // Handle null/undefined values
        if (value == null) {
          return "";
        }
  
        // Escape commas and quotes
        if (typeof value === "string") {
          value = `"${value.replace(/"/g, '""')}"`; // Escape double quotes
        }
  
        return value;
      }).join(",");
    });
  
    // Combine headers and data
    const csvContent = [headers, ...csvData].join("\n");
  
    // Create and download CSV file
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", `${fileName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getFilename = () => {
    if(selectedMenu === 'reports'){
      return selectedMenu+'.'+reportTile
    }
    return selectedMenu;

  }

  // Custom Export Toolbar: Extends Default Toolbar, Only Overrides Export
const CustomToolbar = ({ rows }) => {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <Button
  variant="text"
  color="primary"
  onClick={() => exportToCSV(rows, updatedColumns, getFilename())}
  style={{ margin: "10px" }}
  startIcon={<FileDownloadOutlined/>}
>
  Export CSV
</Button>
    </GridToolbarContainer>
  );
};

const totalColumnWidth = useMemo(() => {
  if (!updatedColumns || updatedColumns.length === 0) return '100%';
  return updatedColumns.reduce((sum, col) => sum + (col.width || col.minWidth || 100), 0);
}, [updatedColumns]);

  return (
    <Card>
      <CardContent>
        <Typography variant="h5" sx={{ fontSize: '1.25rem', margin: '10px' }}>
          {capitalizeFirstLetter(selectedMenu)}
        </Typography>
        {selectedMenu === 'admin' && (
          <>
            {' '}
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              textColor="primary"
              indicatorColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              sx={{ padding: '10px' }}
            >
              {tabLabels.map((label, index) => (
                <Tab
                  key={index}
                  label={label}
                  sx={{ fontSize: '1.0rem', textTransform: 'capitalize' }}
                />
              ))}
            </Tabs>
          </>
        )}

        {selectedMenu === 'admin' &&
        (activeTab == 1 || activeTab == 3 || activeTab == 5) ? (
          <RoleGroupManager
            brandSecurity={
              activeTab == 1
                ? brandSecurity
                : activeTab == 3
                  ? locationSecurity
                  : servicerAppSecurity
            }
          />
        ) : (
          <>
            <div style={{ overflowX: 'unset' }}>
              {selectedMenu === 'reports' && (
                <Box sx={{ display: 'flex' }}>
                  <FormControl>
                    <InputLabel id="reportTile-label">{reportTile}</InputLabel>
                    <Select
                      labelId="reportTile-label"
                      id="reportTile"
                      value={reportTile}
                      label={reportTile}
                      onChange={handleChange}
                    >
                      {AppConfig.reports.map((item, index) => {
                        if (
                          isbrandAdminRole ||
                          superAdmin ||
                          (permissions &&
                            permissions[
                              `dash:brands:${selectedMenu}:${item.toLowerCase()}:view`
                            ])
                        )
                          return (
                            <MenuItem key={index + '-' + item} value={item}>
                              {item}
                            </MenuItem>
                          );
                      })}
                    </Select>
                  </FormControl>
                  <Tooltip title={AppConfig.reportMapping[reportTile]}>
                    <Info />
                  </Tooltip>
                  {reportTile == AppConfig.reports[2] && (
                    <Box>
                      <FormGroup row>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={checked}
                              onChange={handleSaleChange}
                              color="primary"
                              name="nonZero"
                            />
                          }
                          label="Sale Amount Non Zero"
                        />
                      </FormGroup>
                    </Box>
                  )}
                </Box>
              )}
              {selectedMenu === 'admin' && (
                <Button
                  variant="outlined"
                  onClick={handleOpen}
                  startIcon={<AddIcon />}
                  sx={{
                    fontSize: '1.0rem',
                    textTransform: 'capitalize',
                    backgroundColor: '#ff6d0f',
                    color: '#fff',
                  }}
                >
                  Invite Internal User
                </Button>
              )}
              {selectedMenu === 'users' && (
                <Button
                  variant="outlined"
                  onClick={handleOpen}
                  startIcon={<AddIcon />}
                  sx={{
                    fontSize: '1.0rem',
                    textTransform: 'capitalize',
                    backgroundColor: '#ff6d0f',
                    color: '#fff',
                  }}
                >
                  Invite User
                </Button>
              )}
              {dataSize == 0 && (
                <div>No data available with the current selection.</div>
              )}
              {dataSize != 0 && (
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-end"
                  my={2}
                  margin="0px"
                >
                  <Pagination
                    count={Math.ceil(filteredRows.length / pageSize)}
                    page={page + 1} // Convert 0-based index to 1-based index
                    onChange={handlePageChange}
                    color="primary"
                  />
                  <Typography
                    variant="body2"
                    sx={{
                      marginRight: '10px',
                    }}
                  >
                    Total Rows : {filteredRows.length}
                  </Typography>
                </Box>
              )}

              {(!isLoading && isError == null) && <Spinner />}
              {dataSize != 0 && (
                <div
                style={{
                  display: 'inline-block', 
                  width: totalColumnWidth, // let container grow exactly to grid width
                  minWidth: totalColumnWidth,
                  overflow: 'visible',
                  height: 'calc(100vh - 100px)',
                }}
              >
                <DataGrid
                  rows={displayedRows}
                  columns={updatedColumns}
                  //autoHeight
                  // pagination={false}
                  slots={{ toolbar: () => <CustomToolbar rows={rows} /> }}
                  estimatedRowCount={
                    selectedReportData?.pagination?.rows_total | 0
                  }
                  pageSize={pageSize}
                  // onPageSizeChange={(newPageSize) =>
                  //   handlePageSizeChange(newPageSize)
                  // }
                  // pageSizeOptions={[25, 50, 100]}
                  rowCount={
                    selectedReportData &&
                    selectedReportData?.pagination?.rows_total | 0
                  }
                  sortModel={sortModel}
                  disableSelectionOnClick
                  onSortModelChange={(model) => setSortModel(model)}
                  // paginationMode="client"
                  sx={{
                    '& .MuiDataGrid-virtualScroller': {
                      overflowY: 'auto !important',
                      overflowX: 'hidden !important',
                    },
                    '& .MuiDataGrid-main': {
                      overflowX: 'hidden !important',
                    },
                    '& .MuiDataGrid-scrollbar.MuiDataGrid-scrollbar--horizontal': {
                        overflowX: 'hidden !important',
                    },
                    '& .MuiDataGrid-root': {
                      overflowX: 'hidden !important',
                    },
                    '& .MuiDataGrid-columnHeader': {
                      height: '80px',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                      position: 'sticky',
                      zIndex: 1000,
                      backgroundColor: '#fff',
                      top: 0,
                    },
                    '& .MuiDataGrid-row--borderBottom': {
                      borderBottom: 'none',
                      paddingTop: '20px',
                      paddingBottom: '10px',
                    },
                    '& .MuiDataGrid-row--borderBottom .MuiDataGrid-columnHeader':
                      {
                        borderBottom: 'none',
                        height: '80px !important',
                      },
                    '& .MuiDataGrid-row--borderBottom .MuiDataGrid-filler': {
                      borderBottom: 'none',
                    },
                    '& .MuiDataGrid-row--borderBottom .MuiDataGrid-scrollbarFiller':
                      {
                        borderBottom: 'none',
                      },
                    '& .MuiDataGrid-root .MuiDataGrid-columnHeaderDraggableContainer':
                      {
                        height: '80px',
                      },
                    '& .MuiDataGrid-columnHeaderTitleContainerContent': {
                      overflow: 'unset !important',
                    },
                    '& .MuiDataGrid-cell': { py: 2 },
                    '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 'bold' },
                  }}
                />
                </div>
              )}
              {dataSize != 0 && (
                <Box display="flex" justifyContent="flex-end" my={2}>
                  <Pagination
                    count={Math.ceil(filteredRows.length / pageSize)}
                    page={page + 1} // Convert 0-based index to 1-based index
                    onChange={handlePageChange}
                    color="primary"
                  />
                </Box>
              )}
            </div>
            {modalOpen && (
              <InviteUserModal
                clientType={clientType}
                open={modalOpen}
                handleClose={handleClose}
                rolesObject={internalInviteroles}
                selectedUser={selectedUser}
                onInvite={(data) => handleInviteExternalUser(data)}
              />
            )}
            {isEditUsertabModalOpen && (
              <EditUsertabModal
                clientType={clientType}
                open={isEditUsertabModalOpen}
                handleClose={handleCloseEditUsertab}
                rolesObject={internalInviteroles}
                selectedUser={selectedUser}
                onUpdateRoles={(data) => handleEditUserRoles(data)}
              />
            )}

            {inviteInternalmodalOpen && (
              <InviteInternalUserModal
                clientType={clientType}
                open={inviteInternalmodalOpen}
                // onClose={() => setModalOpen(false)}
                onClose={() => setInviteInternalmodalOpen(false)}
                data={internalInvitebrandsorlocations}
                rolesObject={internalInviteroles}
                onInvite={(data) => handleInviteInternalUser(data)}
              />
            )}

            {isEditModalOpen && (
              <OrganizationRoleManager
                activeTab={activeTab}
                open={isEditModalOpen}
                onClose={() => setEditModalOpen(false)}
                onSubmit={handleSave}
                brands={brands}
                locations={locations}
                security={
                  activeTab == 0
                    ? brandSecurity
                    : activeTab == 2
                      ? locationSecurity
                      : servicerAppSecurity
                }
                selectedUser={selectedUser}
              />
            )}
            {confirmationModalOpen && (
              <ConfirmationModal
                open={confirmationModalOpen}
                title="Confirm Deletion"
                message={`Are you sure you want to delete ${userToDelete.email}?`}
                onConfirm={handleDeleteConfirm}
                onCancel={handleDeleteCancel}
              />
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default TableView;
